const headerTrad = {
    fr: {
        projects: "Projets",
        bio: "Bio",
        contact: "Contact",
    },
    en: {
        projects: "Projects",
        bio: "Bio",
        contact: "Contact",
    },
};

export default headerTrad;
